export const ERROR_TYPES: Dict<string> = {
  ERROR_404: 'ERROR_404',
  ERROR_500: 'ERROR_500',
  FILE_UPLOAD_REQUIRED: 'FILE_UPLOAD_REQUIRED',
};
